// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1BVxV","requiredAsterisk":"Info_requiredAsterisk__mvohO"};